import { StandardPage } from 'src/legacy/components/UI/StandardPage/StandardPage';

export * from './useNoClientDescription';

export default StandardPage;
